import { CmsPageAppearanceDrawer } from "@/components/cms/theme/CmsPageAppearanceDrawer";
import {
  type CmsPageAppearanceConfigState,
  useCmsPageAppearance,
} from "@/context/cms/CmsPageAppearanceContext";
import { useEffect } from "react";

type Props = CmsPageAppearanceConfigState;

/**
 * Registers the active CMS form for the Apparence drawer.
 * Must be rendered inside the page FormProvider (drawer uses RHF context).
 */
const LOGIN_SIGNUP_FORM_ID = "login-signup";

export function CmsPageAppearanceConfig({ formId, formPrefix }: Props) {
  const { setConfig, setFormPrefix, clearConfig } = useCmsPageAppearance();

  useEffect(() => {
    setConfig({ formId, formPrefix });
    if (formPrefix === undefined && formId === LOGIN_SIGNUP_FORM_ID) {
      setFormPrefix("login");
    }
    return () => clearConfig();
  }, [formId, formPrefix, setConfig, setFormPrefix, clearConfig]);

  return <CmsPageAppearanceDrawer />;
}
